import React, { useState } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Box, toast } from '@node-space/ui-components'
import { useCustomerEarningsSummaryQuery } from 'hooks/queries/Rewards/useCustomerEarningsSummaryQuery'
import { RewardsEmbeddedDisburseDialog } from './RewardsEmbeddedDisburseDialog'
import { RewardsEmbeddedEarningsChart } from './RewardsEmbeddedEarningsChart'
import { RewardsEmbeddedGiveBack } from './RewardsEmbeddedGiveBack'
import { RewardsEmbeddedSummary } from './RewardsEmbeddedSummary'

const BASE_CURRENCY = 'USDC'
const USER_CURRENCY = 'USD'

export const RewardsEmbeddedCustomer = () => {
  const { t } = useTranslation()
  const [openDisburseDialog, setOpenDisburseDialog] = useState(false)
  const [hasBeenDisbursed, setHasBeenDisbursed] = useState(false)

  const { data: customerEarningsSummary, isLoading: isLoadingCustomerEarningsSummary } =
    useCustomerEarningsSummaryQuery({
      currency: BASE_CURRENCY,
    })

  const handleDisburse = () => {
    toast({
      header: t('rewards.embeddedCustomers.disburseDialog.successMessage'),
      variant: 'success',
    })
    setHasBeenDisbursed(true)
    setOpenDisburseDialog(false)
  }

  const onOpenDisburseDialog = () => {
    setOpenDisburseDialog(true)
  }

  return (
    <Box flexCol gap={16}>
      <Box
        gap={16}
        flexCol
        className={clsx({
          'xl:grid xl:grid-cols-2': !hasBeenDisbursed,
        })}
      >
        <RewardsEmbeddedSummary
          currency={BASE_CURRENCY}
          userCurrency={USER_CURRENCY}
          totalBalance={customerEarningsSummary?.totalPrincipalBalance || '0'}
          totalEarnings={customerEarningsSummary?.totalEarnedAmount || '0'}
          hasBeenDisbursed={hasBeenDisbursed}
          isLoading={isLoadingCustomerEarningsSummary}
        />

        <RewardsEmbeddedGiveBack
          onDisburse={onOpenDisburseDialog}
          hasBeenDisbursed={hasBeenDisbursed}
        />
      </Box>

      <RewardsEmbeddedEarningsChart currency={BASE_CURRENCY} />

      <RewardsEmbeddedDisburseDialog
        onDisburse={handleDisburse}
        open={openDisburseDialog}
        onClose={() => setOpenDisburseDialog(false)}
      />
    </Box>
  )
}
